/***
*
*   AUDIENCE
*   Search for leads and their corporate emails
*
**********/

import React, { Fragment, useState, useContext } from 'react';
import { Card, Button, Form, ViewContext, ProgressBar } from 'components/lib';
import axios from 'axios';
import Style from './audience.module.scss';
import { Table } from 'components/table/table';
import settings from 'settings';

const backgroundServerURL = settings[process.env.NODE_ENV].backgroundcheck_base_url;

const HEADER_FIELDS = [
  {
    title: '-',
    name: 'n'
  },
  {
    title: 'Compañía',
    name: 'company'
  },
  {
    title: 'Nombre',
    name: 'name'
  },
  {
    title: 'Linkedin headline',
    name: 'headline'
  },
  {
    title: 'Email',
    name: 'email'
  },
  {
    title: 'Posibles emails',
    name: 'possibleEmail'
  },
  {
    title: 'Ciudad',
    name: 'city'
  },
  {
    title: 'Acciones',
    name: 'actions'
  }
];

function EcuadorLegalDataweb({ fullName, title }){
  return <h2>{fullName}</h2>;
}

function FiscaliaDataweb({ juicios, title }){
  return (
    <Fragment>
      <h3>{title}</h3>
      <hr/>
      {typeof(juicios) === "string" && (
        <p>{juicios}</p>
      )}
      {typeof(juicios) !== "string" && (
        <ul>
          {juicios.map((juicio, index) => <li key={`fisj-${index}`}>{juicio}</li>)}
        </ul>
      )}
    </Fragment>
  );

}

function FuncionJudicialDataweb({ 
  juiciosDefendant,
  juiciosPlaintiff,
  title 
}){

  return (
    <Fragment>
      <h3>{title}</h3>
      <hr/>
      {typeof(juiciosDefendant) === "string" && (
        <p>{juiciosDefendant}</p>
      )}
      {typeof(juiciosDefendant) !== "string" && (
        <section>
          {juiciosDefendant.length === 0 ? (
            <p>El usuario no tiene juicios en contra registrados en la función judicial</p>
          ) : (
            <>
              <p>El usuario tiene los siguientes juicios en contra en la función judicial:</p>
              <ul>
                {juiciosDefendant.map((juicio, index) => <p><li key={`fj-${index}`}>{juicio}</li></p>)}
              </ul>
            </>
          )}
          {juiciosPlaintiff.length === 0 ? (
            <p>El usuario no tiene juicios realizados registrados en la función judicial</p>
          ) : (
            <>
              <p>El usuario tiene los siguientes juicios realizados en la función judicial:</p>
              <ul>
                {juiciosPlaintiff.map((juicio, index) => <p><li key={`fj-plaintiff-${index}`}>{juicio}</li></p>)}
              </ul>
            </>
          )}
        </section>
      )}
    </Fragment>
  );
}

function MigracionDataweb({ migracion, title }){
  return (
    <Fragment>
      <h3>{title}</h3>
      <hr/>
      {typeof(migracion) === "string" && (
        <p>{migracion}</p>
      )}
      {typeof(migracion) !== "string" && (
        <p>El usuario {migracion.apellidos_nombres} {migracion.con_impedimentos ? "tiene" : "no tiene"} impedimentos de salida del país.</p>
      )}
    </Fragment>
  );
}

function SenescytDataweb({ degrees, title }){

  return (
    <Fragment>
      <h3>{title}</h3>
      <hr/>
      {typeof(degrees) === "string" && (
        <p>{degrees}</p>
      )}
      {typeof(degrees) !== "string" && (
        <ul>
          {degrees.map((degree, index) => (
            <p key={`degree-${index}`}>
              <li>Titulo: {degree.titulo}</li>
              <li>Institución: {degree.institucion}</li>
              <li>Tipo: {degree.tipo}</li>
              <li>Fecha de registro: {degree.fecha_registro}</li>
              <li>Área: {degree.area}</li>
            </p>
          ))}
        </ul>
      )}
    </Fragment>
  );
}

function SuperciasDataweb({ records, title }){

  return (
    <Fragment>
      <h3>{title}</h3>
      <hr/>
      {typeof(records) === "string" && (
        <p>{records}</p>
      )}
      {typeof(records) !== "string" && (
        <section>
          {records.length !== 0 ? (
            <ul>
              {records.map((record, index) => (<li key={`company-${index}`}><p><ul>
                <li>Participación: {record.tipo_participacion}</li>
                <li>Compañía: {record.nombre_compania}</li>
                <li>Ruc: {record.ruc}</li>
                <li>Estado: {record.estado}</li>
              </ul></p></li>))}
            </ul>
          ) : (
            <p>El usuario no es accionista ni representante de ninguna compañía</p>
          )}
        </section>
        
      )}
    </Fragment>
  );
}

/**
 * Parse background result to get useful information 
 */
function parseBackgroundResult({backgroundResult}){
  const ecuadorLegalDataweb = backgroundResult.datawebs_results.ecuador_legal_dataweb;
  const fiscaliaDataweb = backgroundResult.datawebs_results.fiscalia_dataweb;
  const funcionJudicialDataweb = backgroundResult.datawebs_results.funcion_judicial_dataweb;
  const migracionDataweb = backgroundResult.datawebs_results.migracion_dataweb;
  const senescytDataweb = backgroundResult.datawebs_results.senescyt_dataweb;
  const superciasDataweb = backgroundResult.datawebs_results.supercias_dataweb;

  const fullName = ecuadorLegalDataweb.scrapping_result.content?.nombre;
  
  const fiscaliaJuicios = !!fiscaliaDataweb.scrapping_result.error_message ?
    fiscaliaDataweb.scrapping_result.error_message :
    typeof(fiscaliaDataweb.scrapping_result.content) === "string" ?
      fiscaliaDataweb.scrapping_result.content : 
      fiscaliaDataweb.scrapping_result.content.map((juicio) => juicio.delito);
  
  const funcionJudicialJuiciosDefendant = !!funcionJudicialDataweb.scrapping_result.error_message ?
    funcionJudicialDataweb.scrapping_result.error_message :
    funcionJudicialDataweb.scrapping_result.content.defendant.map((juicio) => juicio.nombre_delito);

  const funcionJudicialJuiciosPlaintiff = !!funcionJudicialDataweb.scrapping_result.error_message ?
    funcionJudicialDataweb.scrapping_result.error_message :
    funcionJudicialDataweb.scrapping_result.content.plaintiff.map((juicio) => juicio.nombre_delito);
  
  const impedimentoSalida = !!migracionDataweb.scrapping_result.error_message ? 
    migracionDataweb.scrapping_result.error_message : migracionDataweb.scrapping_result.content;
  
  const education = !!senescytDataweb.scrapping_result.error_message ? 
    senescytDataweb.scrapping_result.error_message : senescytDataweb.scrapping_result.content;

  const companies = !!superciasDataweb.scrapping_result.error_message ?
    superciasDataweb.scrapping_result.error_message : superciasDataweb.scrapping_result.content;

  return {
    companies,
    education,
    impedimentoSalida,
    funcionJudicialJuiciosDefendant,
    funcionJudicialJuiciosPlaintiff,
    fiscaliaJuicios,
    fullName,
    ecuadorLegalDataweb,
    fiscaliaDataweb,
    funcionJudicialDataweb,
    migracionDataweb,
    senescytDataweb,
    superciasDataweb,
  }
}

function BackgroundResults({backgroundResult}){

  if (!backgroundResult) return null;

  const {
    companies,
    education,
    fullName,
    fiscaliaJuicios,
    impedimentoSalida,
    funcionJudicialJuiciosDefendant,
    funcionJudicialJuiciosPlaintiff
  } = parseBackgroundResult({ backgroundResult });

  return (
    <Fragment>
      <EcuadorLegalDataweb
        title={"Ecuador legal"}
        fullName={fullName}
      />
      <FiscaliaDataweb
        title={"Fiscalía General del Estado"}
        juicios={fiscaliaJuicios}
      />
      <FuncionJudicialDataweb
        title={"Función Judicial"}
        juiciosDefendant={funcionJudicialJuiciosDefendant}
        juiciosPlaintiff={funcionJudicialJuiciosPlaintiff}
      />
      <MigracionDataweb
        title={"Estatus Migratorio"}
        migracion={impedimentoSalida}
      />
      <SenescytDataweb
        title={"Senescyt"}
        degrees={education}
      />
      <SuperciasDataweb
        title={"Superintendencia de Compañías"}
        records={companies}
      />
    </Fragment>
  );
}

function AudienceBackground({
  lead,
  zohoAction
}){
  const context = useContext(ViewContext);
  // store streaming messages
  const [progress, setProgress] = useState([]);
  // define how many streaming message this process will be received
  const stepsCounter = 24; // 6 sources are accessed, each has 4 steps
  
  const handleProgress = async (done, message) => {
    // If done is false, then the process is in progress yet
    if (done)
      return;
    
    setProgress(prev => [...prev, message]);
  }

  const handleZohoAction = async (backgroundResult) => {
    
    const {
      fullName,
      fiscaliaDataweb,
      superciasDataweb,
      funcionJudicialDataweb,
      senescytDataweb,
      migracionDataweb
    } = parseBackgroundResult({ backgroundResult });

    let funcionJudicialStr = typeof(funcionJudicialDataweb.scrapping_result.error_message) === "string" ? "N/A" : "/";

    if (funcionJudicialStr === "/"){
      funcionJudicialStr = `
      - Juicios como demandante: ${funcionJudicialDataweb.scrapping_result.content.plaintiff.length > 0 ? "SI" : "NO"} 
      - Juicios como demandado: ${funcionJudicialDataweb.scrapping_result.content.defendant.length > 0 ? "SI" : "NO"}
      `;
    }

    let superciasStr = typeof(superciasDataweb.scrapping_result.error_message) === "string" ? "N/A" : "/";

    if (superciasStr === "/"){
      const currentParticipation = superciasDataweb.scrapping_result.content.filter((record)=>record.estado.toUpperCase().endsWith("ACTUAL"));
      
      if (currentParticipation.length > 0){
        
        const accionista = currentParticipation.filter((record) => record.tipo_participacion === "ACCIONISTA");
        const representanteLegal = currentParticipation.filter((record) => record.tipo_participacion === "GERENTE GENERAL");

        superciasStr = `
        - Accionista: ${accionista.length > 0 ? "SI" : "NO"}
        - Representante Legal: ${representanteLegal.length > 0 ? "SI" : "NO"}
        `;

      }else{
        
        superciasStr = `
        - Accionista: NO
        - Representante Legal: NO
        `;
      
      }
    }

    const fiscaliaStr = fiscaliaDataweb.scrapping_result.error_message ? "N/A" :
      typeof(fiscaliaDataweb.scrapping_result.content) === "string" ? "NO":
      fiscaliaDataweb.length > 0 ? "SI" : "NO";
    
    const educationStr = senescytDataweb.scrapping_result.error_message ? "N/A" :
      typeof(senescytDataweb.scrapping_result.content) === "string" ? "NO" : "SI";

    const impedimentoSalidaStr = migracionDataweb.scrapping_result.error_message || 
      typeof(migracionDataweb.scrapping_result.content) === "string" ? "N/A" : 
      migracionDataweb.scrapping_result.content.con_impedimentos ? "SI" : "NO"
    
    const backgroundString = `
    Nombre:  ${fullName}
    Migración: 
    - Tiene impedimento de salida: ${impedimentoSalidaStr}
    Funcion Judicial: ${funcionJudicialStr}
    Fiscalía: 
    - Tiene juicios en fiscalía: ${fiscaliaStr}
    Supercias: ${superciasStr}
    Senescyt: 
    - Tiene titulos registrados: ${educationStr}
    `;
    
    // Attach background records
    const backgroundLead = {
      ...lead,
      backgroundCheck: backgroundString
    }

    context.modal.hide();
    await zohoAction(backgroundLead);
  
  }
  
  let progressCounter = Math.round((Math.min(progress.length/stepsCounter, 1)*100));

  return (
    <Fragment>
      <Form 
        method='POST'
        url={`${backgroundServerURL}/user/confidence`}
        buttonText='Consultar'
        stream={true}
        progressCallback={handleProgress}
        data={{
          dni: {
            label: 'Número de cédula',
            type: 'text',
            required: true,
            errorMessage: 'Debes introducir una cédula',
          }
        }}
      />
      { progress.length !==0 && 
        !("confidence_score" in progress[progress.length - 1]) &&
        (
          <ProgressBar
            label={`${progressCounter}%`}
            progress={`${progressCounter}%`}
          />
        )
      }
      { progress.length !== 0 &&
        "confidence_score" in progress[progress.length - 1] &&
        (
          <section
            className={Style.backgroundResultsContainer}
          >
            <div
              className={Style.backgroundSendZohoContainer}
            >
              <Button
                text="Enviar a zoho"
                btnOpacity="brand"
                action={() => handleZohoAction(progress[progress.length - 1])}
              />
            </div>
            <BackgroundResults
              backgroundResult={progress[progress.length - 1]}
            />
          </section>
        )
      }
    </Fragment>
  );
}

export function Audience(props){

  const [customerList, setCustomerList] = useState(null);
  const context = useContext(ViewContext);

  /**
   * Handle search email action for a given row.
   * @param {Object} id - The row id.
   */    
  const handleSearchEmail = async (id) => {
    context.setLoading(true);
    const result = await axios.get(`/api/utility/scraper/linkedin/${id}/email`);
    context.setLoading(false);

    // Handle exceptions
    if (result.status >= 500 || !(result.data) || !(result.data.data)) return context.notification.show('Hubo un error al obtener el correo. Inténtelo más tarde.', 'error', true);

    if ("errorMessage" in result.data.data) return context.notification.show(result.data.data.errorMessage, 'error', true);

    // Request successfully served
    const emails = result.data.data.results;

    let corporateEmails = emails.map((emailObj) => emailObj.correosCorporativos ? emailObj.correosCorporativos.join(", ") : '').join(', ');
    let possibleEmails = emails.map((emailObj) => emailObj.correosGenerados ? emailObj.correosGenerados.join(", ") : '').join(', ');

    if (!corporateEmails) corporateEmails = "--";
    if (!possibleEmails) possibleEmails = "--";
        
    return { email: corporateEmails, possibleEmail: possibleEmails };
  }

  /**
   * Handle navigation to LinkedIn profile for a given row.
   * @param {Object} linkedinProfileId - The linkedin profile value.
   */
  const handleGoToLinkedin = (linkedinProfileId) => {
    const linkedinUrl = `https://www.linkedin.com/in/${linkedinProfileId}`;
    if (linkedinUrl)
      window.open(linkedinUrl, '_blank');
  }

  /**
   * Send lead information to zoho CRM
   * @param {Object} lead lead data
   */
  const handleSendLeadToZoho = async (lead) => {
    // Remove default email value
    if (lead.email === "--") lead.email = null;

    context.setLoading(true);
    const result = await axios.post(`/api/integrations/zoho/leads`, {
      list: [ lead ]
    });
    context.setLoading(false);

    // Handle exceptions
    if (result.status >= 500 || !(result.data) || !(result.data.data)) return context.notification.show('Hubo un error al obtener el correo. Inténtelo más tarde.', 'error', true);

    if ("errorMessage" in result.data.data) return context.notification.show(result.data.data.errorMessage, 'error', true);

    // Inspect uploading status
    const uploadingInfo = result.data.data;
    
    if (uploadingInfo.failed) return context.notification.show('El lead no pudo ser sincronizado a zoho. Inténtalo más tarde.', 'error', true);

    return context.notification.show('Lead cargado a zoho con éxito.', 'success', true);
  }

  /**
   * Retrieve background information of a lead.
   * This action will call a modal containing an input
   * for typing his/her dni and date of birth if it is know.
   */
  const handleBackgroundCheck = (lead) => {
    context.modal.show({
      title: "Revisión de antecedentes",
      text: "Inserta el número de cédula para consultar diferentes fuentes del gobierno.",
      components: <AudienceBackground lead={lead} zohoAction={handleSendLeadToZoho}/>
    });
  }

  /**
   * Handle leads results received from the scraping API.
   * @param {Object} leadsData - The data object containing leads information.
   * 
   * If the leadsData is invalid or does not contain the expected structure,
   * a notification is shown to the user indicating an error in obtaining leads.
   * Otherwise, the leads is processed and set to customerList.
   */
  const handleLeadsResults = (leadsData) => {
    
    if (!leadsData || !leadsData.data || !leadsData.data.results){
      context.notification.show("Hubo un error al obtener los leads. Si el error persiste, contáctate con el administrador", 'error', false)
      return;
    }

    // If leads are not found, return an empty list
    if (typeof leadsData.data.results === "string") return setCustomerList([]);
    

    // Map the leads data to the desired format
    const results = leadsData.data.results.map((lead, idx)=>({
      n: idx + 1,
      company: lead.company,
      name: lead.fullName,
      headline: lead.headline,
      email: lead.email || '--',
      possibleEmail: '--',
      city: lead.city || '--',
      actions: {
        custom: [
          { icon: 'mail', action: (_) => handleSearchEmail(lead._id)},
          { icon: 'linkedin', action: (_)=> handleGoToLinkedin(lead.linkedinProfileId) },
          { icon: 'send', action: handleSendLeadToZoho},
          { icon: 'user-check', action: handleBackgroundCheck }
        ]
      }
    }))
    setCustomerList(results);
  };


  return (
    <Fragment>
      <Form 
        data={{ 
          amount: {
            label: 'Cantidad de leads que necesitas (El límite máximo es 20)',
            type: 'number',
            required: true,
            errorMessage: 'Debes introducir un número',
            max: 21
          },
          company: {
            label: 'Empresa de la cual buscas',
            type: 'text',
            required: true,
            errorMessage: 'Debes ingresar un nombre',
            class: Style.fieldMarginCompany
          },
          title: {
            label: 'Puesto de trabajo',
            type: 'text',
            required: true,
            errorMessage: 'Debes ingresar su puesto de trabajo',
            class: Style.fieldMarginPosition
          },
          location: {
            label: 'Ubicación',
            type: 'select',
            required: false,
            class: Style.fieldMarginPosition,
            options: [
              { value: 'Ecuador', label: 'Ecuador' },
              { value: 'Estados Unidos', label: 'Estados Unidos' }
            ]
          }
        }}
        method='POST'
        url='/api/utility/scraper/linkedin'
        callback={ e => handleLeadsResults(e.data) }
        buttonText='Buscar leads'
        display='inline-block'
        beforeSubmitHook={(data) => setCustomerList(null)}
      />

      {customerList && customerList.length === 0 &&
        <Card>
          <p>No se encontraron leads con los criterios de búsqueda utilizados.</p>
        </Card>
      }

      {customerList && customerList.length !== 0 &&
        <Card>
          <Table
            data={customerList}
            header={HEADER_FIELDS}
          />
        </Card>
      } 
    </Fragment>
  )
}
